import Vue from 'vue'
import VueAuth from '@websanova/vue-auth'

import { apiURL } from './config.js'

Vue.use(VueAuth, {
  auth: {
    request: function (req, token) {
      if (req.url.indexOf(apiURL) !== -1) {
        this.options.http._setHeaders.call(this, req, {Authorization: 'Bearer ' + token})
      }
    },
    response: function (res) {
      return res.data.access_token
    }
  },
  http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
  loginData: {
    url: `${apiURL}/clients/mobile/login`
  },
  fetchData: {
    url: `${apiURL}/userinfo`
  },
  refreshData: {
    enabled: false
  },
  logoutData: {
    url: `${apiURL}/logout`,
    makeRequest: true,
    redirect: false
  }
})



// WEBPACK FOOTER //
// ./src/auth.js